import { render, staticRenderFns } from "./ConstraintsPage.vue?vue&type=template&id=537cab07&scoped=true"
import script from "./ConstraintsPage.vue?vue&type=script&lang=js"
export * from "./ConstraintsPage.vue?vue&type=script&lang=js"
import style0 from "./ConstraintsPage.vue?vue&type=style&index=0&id=537cab07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537cab07",
  null
  
)

export default component.exports